import {
  useOutlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useEffect, useLayoutEffect, useRef, useState } from "react";

import SideNavBar from "components/blocks/sidenav/SideNavBar";
import HeaderNavBar from "components/blocks/headernav/HeaderNavBar";
import InnerContainer from "components/atoms/inner/InnerContainer";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import * as s from "../default/DefaultTemplateStyled";
import * as mediaQuery from "components/MediaQuery";
import { setPageContainer } from "redux/reducers/htmlContainer/htmlContainerReducer";
import { setOffPopup } from "redux/reducers/menu/userPopup";
import { useProSidebar } from "react-pro-sidebar";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAuth } from "components/Auth";
import { useNoticeHeight } from "components/NoticePovider";
import { useMenu } from "hook/useMenu";
import TransferAdmin from "pages/users/admin/TransferAdmin";
import Announcement from "components/blocks/announcement/Announcement";
import { getCookie } from "cookies/cookie";
import { ACCESS_TOKEN } from "api/axiosInstance";
import { SUSPENSION_STATUS } from "redux/stomp/stompSubscriptionSlice";
import DWIntercom from "components/blocks/Intercom";

export const MainLayout = () => {
  const dispatch = useAppDispatch();
  const outlet = useOutlet();
  const location = useLocation();
  const navigate = useNavigate();
  const { checkPermissionLocation } = useMenu({});
  const [searchParams] = useSearchParams();
  const searchAccountId = searchParams.get("account") as string | null;
  const searchRoleId = searchParams.get("r") as string | null;

  // menu collapse 상태
  const { collapsed } = useProSidebar();
  const isPopup: boolean = useAppSelector((state) => state.userPopup);
  const pageContainerReq: number = useAppSelector(
    (state) => state.htmlContainer.pageContainerReq
  );
  const { user } = useAuth();
  const { noticeHeight } = useNoticeHeight();
  const buttonRef = useRef<any>(null);

  // 지도 화면일 때 꽉찬 화면으로 나오도록 확인하는 변수
  // console.log(location.pathname);
  // 지도 화면일 때 꽉찬 화면으로 나오도록 확인하는 변수
  const isMobile = mediaQuery.useIsMobile();
  const isAdminandMap =
    location.pathname.includes("/dashboard/map") ||
    // isHelp ||
    location.pathname.includes("/dashboard/admin") ||
    location.pathname.includes("/help/about") ||
    (isMobile && location.pathname.includes("/dashboard"));

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const innerContainerRef = useRef<HTMLDivElement>();
  const accountId = searchParams.get("account") || searchParams.get("accountId");
  const isMyAccount = !!accountId && accountId === selectedAccount.accountId;

  useEffect(() => {
    if (!user.userId) return;
    if (selectedAccount.isSuspended === SUSPENSION_STATUS.DISABLED) return;

    let cancelled = false;
    setIsLoading(true);

    checkPermissionLocation()
      .then((result) => {
        if (cancelled) return;
        // true: 권한 OK / false: 접근 불가 / undefined: stale·중단(후속 effect가 재검사)
        if (result === true) {
          setIsLoading(false);
        } else if (result === false) {
          navigate(-1);
        }
      })
      .catch(() => {
        if (cancelled) return;
        navigate(-1);
      });

    return () => {
      cancelled = true;
    };
  }, [location.pathname, searchAccountId, searchRoleId, user.userId]);

  useEffect(() => {
    const onClick = (event: any) => {
      if (isPopup) {
        dispatch(setOffPopup());
      }
    };
    document.body.addEventListener("click", onClick);
    return function cleanup() {
      window.removeEventListener("click", onClick);
    };
  }, [isPopup]);

  const isVideoShare = location.pathname === "/videoShare";
  const isDashboard = location.pathname.includes("/dashboard/map");

  useEffect(() => {
    dispatch(setPageContainer(innerContainerRef.current));
  }, [pageContainerReq]);

  useEffect(() => {
    if (!getCookie(ACCESS_TOKEN)) {
      navigate("/login");
    }
  }, [user]);

  if (!isMyAccount) {
    return <></>;
  }

  if (selectedAccount.accountId && user.email && !isLoading) {
    return (
      <>
        <s.Layout noticeHeight={noticeHeight} isCollapsed={collapsed}>
          <SideNavBar />

          <s.ContentsContainer
            isVideoShare={isVideoShare}
            isOpen={collapsed}
            isDashboard={isDashboard}
          >
            <HeaderNavBar buttonRef={buttonRef} />
            <InnerContainer map={isAdminandMap} id="inner-container">
              {outlet}
            </InnerContainer>
          </s.ContentsContainer>
        </s.Layout>
        <DWIntercom />
        <TransferAdmin />
        <Announcement />
      </>
    );
  }

  return <></>;
};
